export const size = (obj: Object) => Object.keys(obj).length;
